// glide-ui: 5
//
// Checkbox — Radix-backed checkbox with accent fill + lucide check.
// props: all Radix CheckboxPrimitive.Root props (checked, onCheckedChange, disabled, name, aria-invalid)
// pair with Label for a clickable target
// <Checkbox checked={v} onCheckedChange={setV} />

import React, { forwardRef } from "react";
import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { Check } from "lucide-react";
import { cn } from "@glide/cn";

export const Checkbox = forwardRef<
  React.ElementRef<typeof CheckboxPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof CheckboxPrimitive.Root>
>(({ className, ...props }, ref) => (
  <CheckboxPrimitive.Root
    ref={ref}
    data-slot="checkbox"
    className={cn(
      "peer cursor-pointer h-4 w-4 shrink-0 rounded-sm border border-accent shadow",
      "outline-none focus-visible:border-focus-ring",
      "focus-visible:ring-focus-ring/50 focus-visible:ring-[3px]",
      "disabled:cursor-not-allowed disabled:opacity-50",
      "data-[state=checked]:bg-accent data-[state=checked]:text-accent-fg",
      "aria-invalid:border-error aria-invalid:ring-error/20",
      className,
    )}
    {...props}
  >
    <CheckboxPrimitive.Indicator
      data-slot="checkbox-indicator"
      className={cn("flex items-center justify-center text-current")}
    >
      <Check className="h-4 w-4" strokeWidth={3} />
    </CheckboxPrimitive.Indicator>
  </CheckboxPrimitive.Root>
));
Checkbox.displayName = CheckboxPrimitive.Root.displayName;
